module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/album_exhibition-30ba8660aaafa5e52b632a7a383f73eb.jpg";